import React from "react";
import Favicon from "react-favicon";
import { useSettings } from "../contexts/SettingsContext";

export const SetFavicon = (props: any) => {
  const { settings } = useSettings();

  if (settings?.brand?.img_path_app_header_logo) {
    return <Favicon url={settings.brand.img_path_app_header_logo} />;
  }

  return <></>;
};
